<template>
  <b-modal size="md" v-model="isShow" hide-footer title="คลัง" centered>
    <b-form-group label="" v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        v-model="selected"
        :options="stockList"
        value-field="id"
        text-field="name"
        stacked
        :aria-describedby="ariaDescribedby"
      ></b-form-radio-group>
    </b-form-group>
    <div class="d-flex justify-content-between align-items-center w-100">
      <b-button variant="outline-primary-color" @click="isShow = false"
        >ยกเลิก</b-button
      >
      <b-button @click="submit">ยืนยัน</b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      stockList: [],
      selected: [],
    };
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  methods: {
    async show() {
      await this.getActiveStock();
      this.isShow = true;
    },
    async getActiveStock() {
      const res = await this.axios.get(
        `${this.$baseUrl}/Inventory/GetActiveStockType/${this.branchId}/0`
      );
      this.stockList = res.detail;
      this.selected = res.detail[0].id;
    },
    submit() {
      this.$emit("submit", [this.selected]);
    },
  },
};
</script>

<style></style>
